import ReactGA from "react-ga4"
import Visual from "../../../containers/UI/RouterSide.png"
import commonClasses from "../ArticleStyle.css"
import classes from "./router.css"
import FatArrow from "../../../containers/UI/FatArrow.svg"

const News = (props) => {

  return (
    <>
      <div className={commonClasses.container}>

        <div className={commonClasses.innerContainer}>
          <h3 className={commonClasses.dateLabel}>Tervuren, June 12th 2025</h3>
          <h1>Allorado launches world's first KNX IoT Router</h1>
          
          <div className={classes.visualContainer}>
            <img src={Visual} className={commonClasses.visual} alt="KNXSupply logo"/>
          </div>

          <p className={commonClasses.contentParagraph}>
            Allorado is proud to officially launch a groundbreaking new product: the <strong>world’s first KNX IoT Router</strong>. This marks a pivotal moment in the evolution of KNX technology — a long-awaited bridge between classic KNX systems and the <strong>emerging KNX IoT ecosystem</strong>.
          </p>
          <p className={commonClasses.contentParagraph}>
            KNX IoT has been in development for years: first as a concept, then as technical specifications, and now finally as real, functional products. Until now, progress on KNX IoT end devices has been limited — not because of a lack of vision, but because one essential piece of the puzzle was missing: a way to connect IoT with existing KNX installations.
          </p>
          <p className={commonClasses.contentParagraph}>
            Today, Allorado changes that by releasing the missing link — <strong>the connection between decades of KNX reliability and the future of secure and scalable building automation, KNX IoT</strong>.
          </p>
          
          <p className={commonClasses.contentSubtitle}>Bridging two worlds</p>
          <p className={commonClasses.contentParagraph}>
            The KNX IoT Router is the bridge between <strong>classic KNX systems</strong> and the new <strong>IPv6-based KNX IoT standard</strong>. While it connects to the network via Ethernet, its true purpose is to enable a future where KNX IoT runs over wireless technologies like <strong>Thread, Wi-Fi, or even LoRa</strong>.<br/><br/>
            At Allorado, we believe this is the core strength of KNX IoT: making building automation <strong>secure, low-power, and cable-free</strong>. The router doesn’t provide wireless itself — but it unlocks the ecosystem that will. For retrofits, upgrading existing installations, and hard-to-reach places, this is where KNX evolves.          </p>
          <p className={commonClasses.contentParagraph}>
            Today marks the beginning of the <strong>KNX IoT era</strong>, ready to bring a new wave of innovation to buildings old and new.
          </p>

          <p className={commonClasses.contentSubtitle}>Certification</p>
          <p className={commonClasses.contentParagraph}>
            KNX IoT end devices have been certifiable since late 2024, but the certification program for KNX IoT routers has not yet officially opened. The Allorado KNX IoT Router will enter formal certification when the KNX Association opens router certification later in 2025.
          </p>

          <p className={commonClasses.contentSubtitle}>A natural next step</p>
          <p className={commonClasses.contentParagraph}>
            At Allorado, we combine deep roots in wireless technology with a strong affinity to the KNX ecosystem. Coming from a background in developing LoRa gateways, we’ve long recognized the potential of extending KNX installations wirelessly — especially in retrofit and hard-to-reach environments. The launch of our KNX IoT Router marks a natural next step in our journey to natively extend KNX wirelessly with LoRa. More on this topic later in 2025.
          </p>

          <div className={commonClasses.callToAction}>
            <h3>Want to step into the future?</h3>
            <div className={commonClasses.orderRow}>
              <button className={commonClasses.orderButton} onClick={() => {
                  ReactGA.event({ category: "Button", action: "KNX-IoT-Router" })
                  window.location = "mailto:sales@allorado.io?subject=Interested in KNX IoT Router"
                }}>Order your router today</button>
              <img src={FatArrow} className={commonClasses.arrow} alt="arrow"/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default News;
